export default __webpack_public_path__ + "static/media/2019.73d0d8e0.svg";